// extracted by mini-css-extract-plugin
export default {"container":"ChoicePartner_container__Hjjxb","head":"ChoicePartner_head__d1VPn","divBar":"ChoicePartner_divBar__hbjEy","row":"ChoicePartner_row__4arem"};